var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"business-contact-edit","toptitle":"B2B Kontakt bearbeiten","title":`${_vm.businessContact.firstName} ${_vm.businessContact.lastName}`,"width":800}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('business-contact-form',{attrs:{"businessContact":_vm.businessContact,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }